import styled, { css } from 'styled-components';

const shouldForwardTypographyProp = (prop: string) => prop !== 'weight' && prop !== 'color';

interface ITypography {
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
  color?: string;
}

export const Display1 = css`
  font-size: 44px;
  line-height: 56px;
`;
export const Display1Text = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Display1};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const Heading1 = css`
  font-size: 32px;
  line-height: 42px;
`;
export const Heading1Text = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Heading1};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const Heading2 = css`
  font-size: 28px;
  line-height: 38px;
`;
export const Heading2Text = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Heading2};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const Heading3 = css`
  font-size: 24px;
  line-height: 32px;
`;
export const Heading3Text = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Heading3};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const Heading4 = css`
  font-size: 20px;
  line-height: 24px;
`;
export const Heading4Text = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Heading4};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const Subhead01 = css`
  font-size: 18px;
  line-height: 26px;
`;
export const Subhead01Text = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Subhead01};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const Subhead02 = css`
  font-size: 16px;
  line-height: 22px;
`;
export const Subhead02Text = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Subhead02};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const Body = css`
  font-size: 16px;
  line-height: 18px;
`;
export const BodyText = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Body};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const BodySmall = css`
  font-size: 14px;
  line-height: 20px;
`;
export const BodySmallText = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${BodySmall};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const BodyXSmall = css`
  font-size: 12px;
  line-height: 16px;
`;
export const BodyXSmallText = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${BodyXSmall};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight};
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

export const Tag = css`
  font-size: 12px;
  line-height: 12px;
`;
export const TagText = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Tag};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight || 600};
    `}
`;

export const Label = css`
  font-size: 12px;
  line-height: 12px;
`;
export const LabelText = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Label};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight || 500};
    `}
`;

export const Button = css`
  font-size: 14px;
  line-height: 14px;
`;
export const ButtonText = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${Button};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight || 500};
    `}
`;

export const ButtonLarge = css`
  font-size: 16px;
  line-height: 16px;
`;
export const ButtonLargeText = styled.p.withConfig({
  shouldForwardProp: shouldForwardTypographyProp,
})<ITypography>`
  ${ButtonLarge};
  ${({ weight }) =>
    weight &&
    css`
      font-weight: ${weight || 500};
    `}
`;
